import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { CSEOutSchoolReportHeader } from "../components/HeaderAttribute";
import * as XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import { useUserCapability } from "../components/ConstantReducerProvider";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
const CSEOutSchoolReport = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [branchName, setBranchName] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindReportOutschoolSData, setBindReportOutschoolData] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      setBranchName(userProfileDatas[0]?.LocationName_en);
      setBranchProject([userProfileDatas[0]?.MstLocationId]);
    }
    BranchProjectFetchData();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  const brangeChange = (updatedOptions) => {
    setShowTable(false);
    setBranchProject(updatedOptions);
    const branchProjectlabels = getBranchProjectsNames(updatedOptions);
    setBranchProjectNamesList(branchProjectlabels);
  };

  const GoButton = async () => {
    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);
    let branchProjectArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    if (!branchProjectValidate) {
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          fromDate: fromDate,
          toDate: toDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "CSEOutSchoolAPI/ReportCSEOutSchool"
      );

      setBindReportOutschoolData(response.data.Table);
      setShowTable(true);
    } else {
      setBranchProjectError("Select Branch/Project");
    }
  };

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  // const handleExport = () => {
  //   const dateRange = {
  //     fromDate: fromDate,
  //     toDate: toDate,
  //   };

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //   };

  //   exportData(
  //     CSEOutSchoolReportHeader.map((column) => column.title),
  //     bindReportOutschoolSData,
  //     dateRange,
  //     selectedOptionsData
  //   );
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
  
    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };
  
      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
      };
  
      if (
        !bindReportOutschoolSData ||
        bindReportOutschoolSData.length === 0
      ) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "CSE OUT SCHOOL REPORT",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: null,
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "CSE OUT SCHOOL REPORT",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: null,
            description: `CSE Out School Report Excel exported successfully. Total Records: ${bindReportOutschoolSData.length}`,
          },
          "Log/IUDLog"
        );
      }
  
      exportData(
        CSEOutSchoolReportHeader.map((column) => column.title),
        bindReportOutschoolSData,
        dateRange,
        selectedOptionsData
      );
    } catch (error) {
      console.error("Export error", error);
  
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "CSE OUT SCHOOL REPORT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: null,
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const titleRow = [
      {
        v: "CSE Out - of School Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Date range row with merged cells
    const dateRangeRow = [
      { v: "" },
      {
        v: "From Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: formatDate(dateRange.fromDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
      {
        v: "To Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "left" },
        },
      },
      {
        v: formatDate(dateRange.toDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Branch information row with merged cells
    const branchRow = [
      { v: "" },
      { v: "" },
      {
        v: "Branch/Project:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.branchProjectData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    // Add empty row for spacing
    const spacingRow = [{ v: "" }];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),
    ];

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Branch,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.YouthGroupName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.YouthName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.YouthId,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Age,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Gender,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.Module1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module2,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module3,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module4,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module5,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module6,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Module7,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: Number(rowData.Noofmodulescompleted || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: rowData.Modules,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Sessions,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.FirstDate,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: Number(rowData.DateDifference || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: rowData.ResourcepersonType1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcepersonType2,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcepersonType3,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcepersonType4,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName2,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName3,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName4,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName5,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName6,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName7,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ResourcePersonName8,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
      ];
    });

    // Combine all rows
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 18 }, // Branch
      { width: 30 }, // IPC  No

      { width: 30 }, // Gender
      { width: 15 }, // Topics1
      { width: 15 }, // Topics2
      { width: 15 }, // Topics3
      { width: 20 }, // Topics4
      { width: 15 }, // Topics5
      { width: 10 }, // Topics6
      { width: 15 }, // Topics7
      { width: 15 }, // Topics8
      { width: 20 }, // Topics9
      { width: 20 }, // Topics10
      { width: 15 }, // Topics1
      { width: 15 }, // Topics2
      { width: 30 }, // Topics3
      { width: 30 }, // Topics4
      { width: 30 }, // Topics5
      { width: 30 }, // Topics6
      { width: 30 }, // Topics7
      { width: 30 }, // Topics8
      { width: 30 }, // Topics9
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 }, // Row Total
      { width: 30 }, // Topics9
    ];

   
    // Set row heights for wrapped content
    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "CSE Out-SchoolReport.xlsx");
  };
  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = CSEOutSchoolReportHeader.map((column) => column.title);

    const data = bindReportOutschoolSData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.YouthGroupName,
        rowData.YouthName,
        rowData.YouthId,
        rowData.Age,
        rowData.Gender,
        rowData.Module1,
        rowData.Module2,
        rowData.Module3,
        rowData.Module4,
        rowData.Module5,
        rowData.Module6,
        rowData.Module7,
        rowData.Noofmodulescompleted,
        rowData.Modules,
        rowData.Sessions,
        rowData.FirstDate,
        rowData.DateDifference,
        rowData.ResourcepersonType1,
        rowData.ResourcepersonType2,
        rowData.ResourcepersonType3,
        rowData.ResourcepersonType4,
        rowData.ResourcePersonName1,
        rowData.ResourcePersonName2,
        rowData.ResourcePersonName3,
        rowData.ResourcePersonName4,
        rowData.ResourcePersonName5,
        rowData.ResourcePersonName6,
        rowData.ResourcePersonName7,
        rowData.ResourcePersonName8,
      ];
    });

    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7,
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center",
        valign: "middle",
        cellPadding: 2,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: 15 }, // Age
        5: { cellWidth: 15 }, // Gender
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Auto adjust width
        11: { cellWidth: "auto" }, // Auto adjust width
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Auto adjust width
        17: { cellWidth: "auto" }, // Auto adjust width
        18: { cellWidth: "auto" }, // Auto adjust width
        19: { cellWidth: "auto" }, // Auto adjust width
        20: { cellWidth: "auto" }, // Auto adjust width
        21: { cellWidth: "auto" }, // Auto adjust width
        22: { cellWidth: "auto" }, // Auto adjust width
        23: { cellWidth: "auto" }, // Auto adjust width
        24: { cellWidth: "auto" }, // Auto adjust width
        25: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("CSE Out-SchoolReport.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) {}
  };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`CSE Out- of School Report`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                <InputText
                  inputType="text"
                  title="Branch/Project"
                  classStar="text-red-500"
                  name="branchName"
                  disabled="true"
                  content={branchName}
                  controlFunc={(e) => setBranchName(e.target.value)}
                />
              )}
            </div>

            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {setFromDate(e.target.value);setShowTable(false);}}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {setToDate(e.target.value);setShowTable(false);}}
              />
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  class="inline-block rounded bg-[#2d2d6e] px-6 pb-2 pt-2.5  text-xs font-medium uppercase leading-normal text-neutral-50 shadow-[0_4px_9px_-4px_rgba(51,45,45,0.7)] transition duration-150 ease-in-out hover:bg-neutral-800 hover:shadow-[0_8px_9px_-4px_rgba(51,45,45,0.2),0_4px_18px_0_rgba(51,45,45,0.1)] focus:bg-neutral-800 focus:shadow-[0_8px_9px_-4px_rgba(51,45,45,0.2),0_4px_18px_0_rgba(51,45,45,0.1)] focus:outline-none focus:ring-0 active:bg-neutral-900 active:shadow-[0_8px_9px_-4px_rgba(51,45,45,0.2),0_4px_18px_0_rgba(51,45,45,0.1)]   "
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable && (
          <div className=" ">
            <ReportGridPage
              title=""
              header={CSEOutSchoolReportHeader}
              records={bindReportOutschoolSData}
              handleExport={handleExport}
              handlePDF={downloadPDF}
            />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default CSEOutSchoolReport;
